import React from 'react';
const Blanket = props => (React.createElement("div", Object.assign({ css: {
        bottom: 0,
        left: 0,
        top: 0,
        right: 0,
        position: 'fixed',
        zIndex: 1,
    } }, props)));
export const DropdownToggle = ({ children, isOpen, target, onClose }) => {
    return (React.createElement(React.Fragment, null,
        target,
        isOpen ? React.createElement(React.Fragment, null, children) : null,
        isOpen ? React.createElement(Blanket, { onClick: onClose }) : null));
};
//# sourceMappingURL=DropdownWrapper.js.map